import { Messages } from '../../codegen/Localize';
import { UserStateParams } from '../config';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { IUserInfo } from '../models/IUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { IResult } from '../ServerApi/types/IResponse';
import { RemoveSelfFromAlertsAction } from '../services/RemoveSelfFromAlertsAction';
import { ServerService } from '../services/ServerService';

export interface AddUserToDataAlertScope extends ng.IScope {
  dataAlert: IDataAlertInfo;
  errorOccurred: boolean;
  actionSuccessful: boolean;
  errorOrSuccessMessage: string;
  userStateParams: UserStateParams;
  undoMessage: string;
  undo: () => void;
}

export interface AddUserToDataAlertStateParams extends ng.ui.IStateParamsService {
  dataAlertId: string;
  userId: string;
}

export class AddUserToDataAlertCtrl {

  public static $inject = [
    '$scope',
    '$state',
    '$stateParams',
    'DataAlerts',
    'ServerService',
    'RemoveSelfFromAlertsAction'
  ];

  public initComplete: ng.IPromise<void>;

  constructor(private $scope: AddUserToDataAlertScope,
              $state: ng.ui.IStateService,
              $stateParams: AddUserToDataAlertStateParams,
              private DataAlerts: DataAlerts,
              ServerService: ServerService,
              private RemoveSelfFromAlertsAction: RemoveSelfFromAlertsAction) {

    $scope.errorOccurred = false;
    $scope.actionSuccessful = false;
    $scope.undoMessage = Messages.addSelfToAlertThroughEmailRemoveMe();

    const currentUser = ServerService.sessionUserInfo();
    $scope.userStateParams = {
      domainName: currentUser.domainName,
      username: currentUser.username
    };

    $scope.undo = () => {
      return this.RemoveSelfFromAlertsAction.removeSelf(Set.singletonForIdItem(this.$scope.dataAlert), { scope: $scope })
        .then(() => $state.go('main.site.user.dataAlerts', $scope.userStateParams, { location: 'replace' }));
    };

    this.initComplete = DataAlerts.getById($stateParams.dataAlertId)
      .then((dataAlert: IDataAlertInfo) => {
        if (dataAlert) {
          this.$scope.dataAlert = dataAlert;
          if (dataAlert.isCurrentUserSubscribed) {
            this.handleUserAlreadyAddedToAlert(dataAlert);
          } else {
            this.tryToAddSelfToAlert(dataAlert, currentUser);
          }
        } else {
          this.handleAlertNotFound();
        }
      })
      .catch(()=> {
        this.handleUnknownError();
      });
  }

  private tryToAddSelfToAlert(dataAlert: IDataAlertInfo, currentUser: IUserInfo) {
    this.DataAlerts.addUsers({ dataAlertIds: [ dataAlert.id ], userIds: [ currentUser.id ] })
      .then((result: IResult) => {
        if (result.errors && result.errors.length > 0) {
            if (result.errors[0].code === 10011) {
              this.handleAddSelfNoEmailAddressError(dataAlert);
            } else {
              this.handleAddSelfError(dataAlert);
            }
        } else {
          this.handleAddSelfSuccess(dataAlert);
        }
      })
      .catch(() => {
        this.handleUnknownError();
      });
  }

  private handleAlertNotFound() {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = Messages.errorDataAlertNotFoundNoName();
  }

  private handleUserAlreadyAddedToAlert(dataAlert: IDataAlertInfo) {
    // Don't set the errorOccurred flag here because this case is success-ish
    this.$scope.actionSuccessful = true;
    this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertsErrorAlreadyAdded({ ALERT_NAME: dataAlert.name });
  }

  private handleAddSelfSuccess(dataAlert: IDataAlertInfo) {
    this.$scope.actionSuccessful = true;
    this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertThroughEmailSuccess({ ALERT_NAME: dataAlert.name });
  }

  private handleAddSelfError(dataAlert: IDataAlertInfo) {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertThroughEmailError({ ALERT_NAME: dataAlert.name });
  }
  private handleUnknownError() {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = Messages.errorUnknown();
  }

  private handleAddSelfNoEmailAddressError(dataAlert: IDataAlertInfo) {
      this.$scope.errorOccurred = true;
      this.$scope.errorOrSuccessMessage = Messages.addSelfToAlertsErrorNoEmailAddress({ ALERT_NAME: dataAlert.name });
  }
}

Module.instance().controller('AddUserToDataAlertCtrl', AddUserToDataAlertCtrl);

